module.exports = __webpack_public_path__ + "media/yolo-3.0/exclamation-circle-solid-07d105f4.svg";